import React from "react";
import { Card, Row, Col, Input, Button, Typography } from "antd";
import { DeleteOutlined, PlusCircleFilled } from "@ant-design/icons";

const { Title } = Typography;

const SentenceSection = ({
  mode,
  selectedSentences = [],
  selectedCharacters = [],
  handleSentencesInputChange,
  handleAddSentence,
  handleRemoveSentence,
  onSave,
  handleDrop,
}) => {
  console.log("[sentenceSection]selected sentences::", selectedSentences);

  const effectiveSentences = selectedSentences
      .slice()
      .sort((a, b) => (a.ord ?? 0) - (b.ord ?? 0));

  // ✅ IMPORTANT: use ref instead of state (no rerenders during drag)
  const dragIndexRef = React.useRef(null);

  const [dragIndex, setDragIndex] = React.useState(null);

  return (
    <Card className="editorContainer" bordered style={{ marginTop: 24 }}>
      <Title level={4}>Sätze</Title>

      {effectiveSentences.map((sentence, index) => (
        <div
          key={sentence.id || sentence.localId}
          draggable
          onDragStart={(e) => {
            dragIndexRef.current = index;
            setDragIndex(index);
            e.currentTarget.style.transform = "scale(0.85)";
            
          }}

          onDragEnd={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
          onDragOver={(e) => e.preventDefault()}
          onDrop={() => {
            handleDrop(dragIndexRef.current, index);
            dragIndexRef.current = null;
          }}
         
        >
          {/* Drag handle */}
          <div
            style={{
              cursor: "grab",
              padding: "4px 0",
              userSelect: "none",
              fontSize: 18,
            }}
            onMouseDown={() => {
              dragIndexRef.current = index;
            }}
          >
            ☰ drag
          </div>

          <Card style={{ marginBottom: 16 }} bordered>
            <Row gutter={[16, 16]}>
              {/* TEXT */}
              <Col span={12}>
                <Input
                  placeholder={`Satz ${index + 1}`}
                  name="text"
                  value={sentence.text}
                  onChange={(e) =>
                    handleSentencesInputChange(e, index)
                  }
                />
              </Col>

              {/* CHARACTER */}
              <Col span={8}>
                <select
                  name="characterid"
                  value={sentence.characterid}
                  onChange={(e) =>
                    handleSentencesInputChange(e, index)
                  }
                  style={{ width: "100%" }}
                >
                  <option value="">
                    Character wählen
                  </option>

                  {selectedCharacters.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))}
                </select>
              </Col>

              {/* DELETE */}
              <Col span={4}>
                <Button
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() =>
                    handleRemoveSentence(index)
                  }
                />
              </Col>
            </Row>
          </Card>
        </div>
      ))}

      {/* ADD */}
      <Button
        icon={<PlusCircleFilled />}
        type="primary"
        onClick={handleAddSentence}
      >
        Satz hinzufügen
      </Button>

    
    </Card>
  );
};

export default SentenceSection;